import React from "react";
import { store } from "../../../../redux/store";
import { setDeploymentMessages } from "../../../../redux/actions/DeploymentActions";
import { validateDomain } from "../../../../helpers/forms/validators/domainBasicDeployment";
import { APP_TYPES } from "./custom";
import { scrollToAnchor } from "../../../../helpers/common";
import { collectCloudMessages } from "../../_components/cloud/_heplers/messages";

// function fillMessage(message, type = 'error', container, block, target) {
//     return {message, type, container, block, target}
// }

function collectProjectMessages(data) {

    let messages = [];

    if (!data.project_name?.length) {
        messages.push({
            message: `A project name is required`,
            type: 'error',
            container: 'project-settings',
            block: `project-settings-name`,
            target: `project-settings-name`,
        })
    }

    if (!!data.project_git_url?.length) {

        const url = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);

        if (!data.project_git_url.match(url)) {
            messages.push({
                message: `Invalid url`,
                type: 'error',
                container: 'project-settings',
                block: `project-settings-git`,
                target: `project-settings-git-url`,
            })
        }
    }

    return messages
}

function collectNetworksMessages(data) {

    let messages = [];

    data.networks?.map(n => {
        if (data.networks.some(_n => _n.name === n.name && _n.id !== n.id)) {
            messages.push({
                message: `Each network should have an unique name!`,
                type: 'error',
                container: 'networks',
                block: `network-${n.id}`,
                target: `network-${n.id}-name`,
            })
        }
    })

    return messages
}

function collectCustomAppMessages(data) {

    let messages = [];
    let selected = [];

    APP_TYPES.map(type => {
        selected = [...selected, ...data[type]]
    })

    selected.map(app => {

        if (!app.custom) return;

        if (!app.name?.length) {
            messages.push({
                message: `An app name is required`,
                type: 'error',
                container: 'services',
                block: `app-${app._id}`,
                target: `app-${app._id}-name`,
            })
        }

        if (!app.dockerhub_name?.length) {
            messages.push({
                message: `Repository is required`,
                type: 'error',
                container: 'services',
                block: `app-${app._id}`,
                target: `app-${app._id}-dockerhub`,
                part: `app-${app._id}-dockerhub-name`,
            })
        }

        if (!!app.url_app?.length) {

            const url = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);

            if (!app.url_app.match(url)) {
                messages.push({
                    message: `Invalid url`,
                    type: 'error',
                    container: 'services',
                    block: `app-${app._id}`,
                    target: `app-${app._id}-meta`,
                    part: `app-${app._id}-url-app`,
                })
            }
        }

        if (!!app.url_git?.length) {

            const url = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);

            if (!app.url_git.match(url)) {
                messages.push({
                    message: `Invalid git url`,
                    type: 'error',
                    container: 'web-apps',
                    block: `app-${app._id}`,
                    target: `app-${app._id}-meta`,
                    part: `app-${app._id}-url-git`,
                })
            }
        }
    })

    return messages
}

function collectDomainMessages(data) {
    let messages = [];

    data.web.map(app => {

        const {isValid, message} = validateDomain(app.domain, false);

        if (!isValid) {
            messages.push({
                message,
                type: 'error',
                container: 'web-apps',
                block: `app-${app._id}`,
                target: `${app._id}-domain`,
            })
        }
    })

    return messages
}

// function collectVersionsMessages(data) {
//     let messages = [];
//
//     APP_TYPES.map(type => data[type].map(app => {
//         if (!app.version && !app.custom) {
//             messages.push({
//                 message: `No version is selected. Please select one or contact support if no versions are available!`,
//                 type: 'error',
//                 container: `${type}-apps`,
//                 block: `app-${app._id}`,
//                 target: `app-${app._id}-version`,
//             })
//         }
//     }))
//
//     return messages
// }

function collectPortsMessages(data) {

    let messages = [];

    const apps = [];
    APP_TYPES.map(type => data[type].map(app => apps.push(app)));

    apps.map(app => {

        app.shared_ports?.map((pair, pairIndex) => {

            if (!pair.host_port) return;

            const duplicatedPortApp = apps.filter(_app => (
                app._id !== _app._id && _app.shared_ports?.some(_pair => _pair.host_port === pair.host_port)
            ));

            const duplicatedLinks = duplicatedPortApp.map((_app, i) => {
                return (
                    <a
                        href='/'
                        onClick={e => {
                            e.preventDefault();
                            scrollToAnchor(`app-${_app._id}`, e, true, 'builder-container');
                        }}
                        key={i}
                    >
                        {_app.name || _app.code || 'User app'}
                    </a>
                )
            })

            const message = (
                <p style={{color: 'var(--colorFontError)'}}>
                    {duplicatedLinks.map((a, i) => (
                        <React.Fragment key={i}>{a}{i + 1 < duplicatedLinks.length ? ', ' : ''}</React.Fragment>
                    ))} {duplicatedLinks.length > 1 ? 'are' : 'is'} already using the same host port!
                </p>
            )

            if (!!duplicatedLinks.length) {
                messages.push({
                    message: message,
                    type: 'error',
                    container: 'services',
                    block: `app-${app._id}`,
                    target: `app-${app._id}-shared_ports`,
                    part: `app-${app._id}-shared_ports-${pairIndex}-host_port`,
                })
            }
        })
    });

    return messages
}

export function collectBuilderMessages(data, responseMessages) {

    const stored = store.getState().deployment.messages;

    let messages = [
        ...collectProjectMessages(data),
        ...collectNetworksMessages(data),
        ...collectCustomAppMessages(data),
        ...collectDomainMessages(data),
        // ...collectVersionsMessages(data),
        ...collectPortsMessages(data),
        ...collectCloudMessages(data),
    ];

    if (JSON.stringify(stored) !== JSON.stringify(messages)) {
        store.dispatch(setDeploymentMessages([...messages, ...responseMessages]))
    }
}